import React, { useState, useEffect } from 'react';
import CongratulationsForm from './CongratulationsForm.jsx';
import { useTranslation } from 'react-i18next';
import { useSendCongratulationsMailMutation } from '../../../../redux/services/mail.jsx';
import { useToastMessages } from '../../../../hooks/useToastMessages.jsx';
import { Form as AntdForm } from 'antd';

const CongratulationsPage = () => {
  const [values, setValues] = useState(undefined);
  const { t, i18n } = useTranslation();
  const [form] = AntdForm.useForm();

  const { successMessage } = useToastMessages();

  const [sendContactMail, { isSuccess: sendSuccess }] =
    useSendCongratulationsMailMutation();

  useEffect(() => {
    document.title = t('Blahoželanie pre FRI UNIZA');
  }, []); // Runs on mount

  useEffect(() => {
    if (sendSuccess) {
      successMessage({
        message: t('Ďakujeme za blahoželanie!'),
        description: t('Vaša správa bola úspešne odoslaná.'),
      });
    }
  }, [sendSuccess]);

  useEffect(() => {
    if (values) {
      // Attach current locale to the data
      const locale =
        i18n.language ||
        (typeof navigator !== 'undefined' ? navigator.language : 'sk');
      sendContactMail({ ...values, locale });
    }
  }, [values]);

  useEffect(() => {
    if (sendSuccess && form && form.resetFields) {
      form.resetFields();
    }
  }, [sendSuccess]);

  const initials = {
    name: undefined,
    email: undefined,
    title: undefined,
    text: undefined,
  };

  return (
    <div style={{ margin: '10px' }}>
      <CongratulationsForm
        form={form}
        initialValues={initials}
        onFinish={setValues}
      />
    </div>
  );
};

export default CongratulationsPage;
